import * as React from 'react';

export const  Chemical =()=> (
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 512 512" enable-background='new 0 0 512 512' xmlSpace="preserve">
<g>
	<polygon style={{fill:'#4EB79B'}} points="197.702,156.845 126.097,156.845 126.084,137.845 197.702,137.845 	"/>
	
		<rect x="31.986" y="300.84" transform="matrix(-0.4999 -0.8661 0.8661 -0.4999 -167.105 524.1878)" style={{fill:'#4EB79B'}} width="71.606" height="19"/>
	<rect x="126.097" y="355.161" style={{fill:'#4EB79B'}} width="71.605" height="19"/>
	
		<rect x="58.286" y="165.867" transform="matrix(-0.8662 -0.4998 0.4998 -0.8662 25.7075 410.24)" style={{fill:'#4EB79B'}} width="19.001" height="71.621"/>
	<path style={{fill:'#4EB79B'}} d="M265.68,454.747l-31.06-53.775c-0.835-1.444-1.273-3.083-1.273-4.751v-9.5l19-0.013v6.967
		l29.787,51.571L265.68,454.747z"/>
	
		<rect x="434.688" y="383.199" transform="matrix(-0.866 -0.5001 0.5001 -0.866 619.3043 1003.9916)" style={{fill:'#4EB79B'}} width="19.001" height="71.619"/>
	
		<rect x="246.486" y="274.537" transform="matrix(-0.866 -0.5001 0.5001 -0.866 322.464 707.1144)" style={{fill:'#4EB79B'}} width="19.001" height="71.619"/>
	
		<rect x="408.381" y="300.831" transform="matrix(-0.5 -0.866 0.866 -0.5 397.536 850.1755)" style={{fill:'#4EB79B'}} width="71.616" height="19"/>
	<rect x="314.298" y="463.829" style={{fill:'#4EB79B'}} width="71.605" height="19"/>
	
		<rect x="58.278" y="383.18" transform="matrix(-0.866 -0.5 0.5 -0.866 -83.0185 815.7051)" style={{fill:'#4EB79B'}} width="19" height="71.591"/>
	
		<rect x="434.714" y="165.888" transform="matrix(-0.866 -0.5 0.5 -0.866 728.0773 598.4846)" style={{fill:'#4EB79B'}} width="19.001" height="71.635"/>
	
		<rect x="220.155" y="192.175" transform="matrix(-0.4999 -0.8661 0.8661 -0.4999 209.26 524.1844)" style={{fill:'#4EB79B'}} width="71.631" height="19"/>
	<rect x="314.298" y="246.494" style={{fill:'#4EB79B'}} width="71.605" height="19"/>
	
		<rect x="246.491" y="57.215" transform="matrix(-0.866 -0.5001 0.5001 -0.866 431.1534 301.5999)" style={{fill:'#4EB79B'}} width="19.001" height="71.619"/>
</g>
<path style={{fill:'#5DACD8'}} d="M287.369,2.248c20.115,0,36.429,16.315,36.429,36.429c0,20.127-16.315,36.429-36.429,36.429
	c-6.637,0-12.857-1.773-18.215-4.877c-10.881-6.295-18.215-18.063-18.215-31.553C250.94,18.563,267.254,2.248,287.369,2.248z"/>
<g>
	<path style={{fill:'#E88158'}} d="M431.047,224.46c10.893,6.27,18.227,18.05,18.227,31.54c0,13.49-7.334,25.27-18.227,31.553
		c-5.358,3.103-11.577,4.877-18.202,4.877c-20.127,0-36.429-16.302-36.429-36.429c0-20.115,16.302-36.429,36.429-36.429
		C419.47,219.571,425.689,221.344,431.047,224.46z"/>
	<path style={{fill:'#E88158'}} d="M242.846,115.792c10.893,6.295,18.215,18.063,18.215,31.553c0,13.477-7.321,25.257-18.215,31.54
		c-5.358,3.116-11.577,4.889-18.215,4.889c-20.115,0-36.429-16.315-36.429-36.429c0-20.127,16.315-36.429,36.429-36.429
		C231.268,110.916,237.488,112.689,242.846,115.792z"/>
	<path style={{fill:'#E88158'}} d="M287.369,219.571c20.115,0,36.429,16.315,36.429,36.429c0,20.127-16.315,36.429-36.429,36.429
		c-6.637,0-12.857-1.773-18.215-4.877C258.274,281.257,250.94,269.49,250.94,256c0-13.477,7.334-25.257,18.215-31.54
		C274.512,221.344,280.732,219.571,287.369,219.571z"/>
	<path style={{fill:'#E88158'}} d="M242.846,396.22c-5.358,3.103-11.577,4.877-18.215,4.877c-20.115,0-36.429-16.315-36.429-36.429
		c0-20.127,16.315-36.442,36.429-36.442c6.637,0,12.857,1.773,18.215,4.889c10.893,6.283,18.215,18.063,18.215,31.553
		C261.06,378.145,253.739,389.925,242.846,396.22z"/>
	<path style={{fill:'#E88158'}} d="M135.597,364.667c0,20.115-16.315,36.429-36.429,36.429c-6.637,0-12.869-1.773-18.227-4.877
		c-10.881-6.308-18.202-18.075-18.202-31.553c0-13.49,7.321-25.257,18.202-31.553c5.358-3.116,11.59-4.889,18.227-4.889
		C119.282,328.225,135.597,344.54,135.597,364.667z"/>
</g>
<g>
	<path style={{fill:'#5DACD8'}} d="M54.644,441.77c10.893,6.308,18.215,18.075,18.215,31.553c0,20.115-16.315,36.429-36.429,36.429
		S0,493.437,0,473.322c0-20.115,16.315-36.429,36.429-36.429C43.067,436.893,49.286,438.666,54.644,441.77z"/>
	<path style={{fill:'#5DACD8'}} d="M287.369,436.893c20.115,0,36.429,16.315,36.429,36.429c0,20.115-16.315,36.429-36.429,36.429
		c-20.115,0-36.429-16.315-36.429-36.429c0-13.477,7.334-25.257,18.215-31.553C274.512,438.666,280.732,436.893,287.369,436.893z"/>
	<path style={{fill:'#5DACD8'}} d="M431.047,441.77c10.893,6.283,18.227,18.063,18.227,31.553c0,20.115-16.315,36.429-36.429,36.429
		c-20.127,0-36.429-16.315-36.429-36.429c0-20.115,16.302-36.429,36.429-36.429C419.47,436.893,425.689,438.666,431.047,441.77z"/>
	<path style={{fill:'#5DACD8'}} d="M475.571,328.225c20.127,0,36.429,16.315,36.429,36.442c0,20.115-16.302,36.429-36.429,36.429
		c-6.637,0-12.857-1.773-18.215-4.889c-10.881-6.283-18.215-18.063-18.215-31.54c0-13.49,7.334-25.27,18.215-31.553
		C462.714,329.999,468.933,328.225,475.571,328.225z"/>
	<path style={{fill:'#5DACD8'}} d="M475.571,110.916c20.127,0,36.429,16.302,36.429,36.429c0,20.115-16.302,36.429-36.429,36.429
		c-6.637,0-12.857-1.773-18.215-4.889c-10.881-6.283-18.215-18.063-18.215-31.54C439.141,127.218,455.456,110.916,475.571,110.916z"
		/>
</g>
<g>
	<path style={{fill:'#4C9CBF'}} d="M475.571,183.775c-6.637,0-12.857-1.773-18.215-4.889c-10.881-6.283-18.215-18.063-18.215-31.54
		c0-20.127,16.315-36.429,36.429-36.429c-9.335,0-16.897,16.302-16.897,36.429c0,13.477,3.407,25.257,8.449,31.54
		C469.605,182.001,472.493,183.775,475.571,183.775z"/>
	<path style={{fill:'#4C9CBF'}} d="M287.369,75.107c-6.637,0-12.857-1.773-18.215-4.889c-10.881-6.283-18.215-18.063-18.215-31.54
		c0-20.127,16.315-36.429,36.429-36.429c-9.335,0-16.897,16.302-16.897,36.429c0,13.477,3.407,25.257,8.449,31.54
		C281.403,73.334,284.291,75.107,287.369,75.107z"/>
</g>
<g>
	<path style={{fill:'#5DACD8'}} d="M54.644,224.46c10.893,6.295,18.215,18.063,18.215,31.54c0,13.49-7.321,25.257-18.215,31.553
		c-5.358,3.103-11.577,4.877-18.215,4.877C16.315,292.429,0,276.127,0,256c0-20.115,16.315-36.429,36.429-36.429
		C43.067,219.571,49.286,221.344,54.644,224.46z"/>
	<path style={{fill:'#5DACD8'}} d="M135.597,147.345c0,20.115-16.315,36.429-36.429,36.429c-6.637,0-12.869-1.773-18.227-4.889
		c-10.881-6.295-18.202-18.063-18.202-31.54c0-20.127,16.302-36.429,36.429-36.429C119.282,110.916,135.597,127.218,135.597,147.345
		z"/>
</g>
<g>
	<path style={{fill:'#4C9CBF'}} d="M412.845,509.752c-6.637,0-12.857-1.773-18.215-4.889c-10.881-6.283-18.215-18.063-18.215-31.54
		c0-20.127,16.315-36.429,36.429-36.429c-9.335,0-16.897,16.302-16.897,36.429c0,13.477,3.407,25.257,8.449,31.54
		C406.879,507.978,409.767,509.752,412.845,509.752z"/>
	<path style={{fill:'#4C9CBF'}} d="M475.571,401.097c-6.637,0-12.857-1.773-18.215-4.889c-10.881-6.283-18.215-18.063-18.215-31.54
		c0-20.127,16.315-36.429,36.429-36.429c-9.335,0-16.897,16.302-16.897,36.429c0,13.477,3.407,25.257,8.449,31.54
		C469.605,399.324,472.493,401.097,475.571,401.097z"/>
	<path style={{fill:'#4C9CBF'}} d="M287.369,509.752c-6.637,0-12.857-1.773-18.215-4.889c-10.881-6.283-18.215-18.063-18.215-31.54
		c0-20.127,16.315-36.429,36.429-36.429c-9.335,0-16.897,16.302-16.897,36.429c0,13.477,3.407,25.257,8.449,31.54
		C281.403,507.978,284.291,509.752,287.369,509.752z"/>
	<path style={{fill:'#4C9CBF'}} d="M36.429,509.752c-6.637,0-12.857-1.773-18.215-4.889C7.334,498.58,0,486.8,0,473.322
		c0-20.127,16.315-36.429,36.429-36.429c-9.335,0-16.897,16.302-16.897,36.429c0,13.477,3.407,25.257,8.449,31.54
		C30.463,507.978,33.351,509.752,36.429,509.752z"/>
	<path style={{fill:'#4C9CBF'}} d="M36.429,292.429c-6.637,0-12.857-1.773-18.215-4.889C7.334,281.257,0,269.477,0,256
		c0-20.127,16.315-36.429,36.429-36.429c-9.335,0-16.897,16.302-16.897,36.429c0,13.477,3.407,25.257,8.449,31.54
		C30.463,290.656,33.351,292.429,36.429,292.429z"/>
	<path style={{fill:'#4C9CBF'}} d="M99.167,183.775c-6.637,0-12.857-1.773-18.215-4.889c-10.881-6.283-18.215-18.063-18.215-31.54
		c0-20.127,16.315-36.429,36.429-36.429c-9.335,0-16.897,16.302-16.897,36.429c0,13.477,3.407,25.257,8.449,31.54
		C93.201,182.001,96.089,183.775,99.167,183.775z"/>
</g>
<g>
	<path style={{fill:'#D37250'}} d="M224.631,401.097c-6.637,0-12.857-1.773-18.215-4.889c-10.881-6.283-18.215-18.063-18.215-31.54
		c0-20.127,16.315-36.429,36.429-36.429c-9.335,0-16.897,16.302-16.897,36.429c0,13.477,3.407,25.257,8.449,31.54
		C218.665,399.324,221.553,401.097,224.631,401.097z"/>
	<path style={{fill:'#D37250'}} d="M99.167,401.097c-6.637,0-12.857-1.773-18.215-4.889c-10.881-6.283-18.215-18.063-18.215-31.54
		c0-20.127,16.315-36.429,36.429-36.429c-9.335,0-16.897,16.302-16.897,36.429c0,13.477,3.407,25.257,8.449,31.54
		C93.201,399.324,96.089,401.097,99.167,401.097z"/>
	<path style={{fill:'#D37250'}} d="M224.631,183.775c-6.637,0-12.857-1.773-18.215-4.889c-10.881-6.283-18.215-18.063-18.215-31.54
		c0-20.127,16.315-36.429,36.429-36.429c-9.335,0-16.897,16.302-16.897,36.429c0,13.477,3.407,25.257,8.449,31.54
		C218.665,182.001,221.553,183.775,224.631,183.775z"/>
	<path style={{fill:'#D37250'}} d="M287.369,292.429c-6.637,0-12.857-1.773-18.215-4.889c-10.881-6.283-18.215-18.063-18.215-31.54
		c0-20.127,16.315-36.429,36.429-36.429c-9.335,0-16.897,16.302-16.897,36.429c0,13.477,3.407,25.257,8.449,31.54
		C281.403,290.656,284.291,292.429,287.369,292.429z"/>
	<path style={{fill:'#D37250'}} d="M412.845,292.429c-6.637,0-12.857-1.773-18.215-4.889c-10.881-6.283-18.215-18.063-18.215-31.54
		c0-20.127,16.315-36.429,36.429-36.429c-9.335,0-16.897,16.302-16.897,36.429c0,13.477,3.407,25.257,8.449,31.54
		C406.879,290.656,409.767,292.429,412.845,292.429z"/>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
)
